import React from 'react';
import { 
    Form, 
    Input, 
    Select, 
    InputNumber, 
    Button, 
    Row, 
    Col, 
    message
} from 'antd';

import {
    _postAddCreditNote
} from '../../services'

const Item = Form.Item;
const Option = Select.Option
const {TextArea} = Input

class CreditNoteForm extends React.Component{
	render(){
		
        const { getFieldDecorator } = this.props.form;


		return (
            <Form 
            className="action-form" onSubmit={this.handleSubmit}>
                            <Row type="flex" gutter={4}>
                                <Col span={6}>
                                    <Item
                                        className="action-form-item"
                                        label="Amount"
                                    >
                                        {getFieldDecorator('amount', {

                                                initialValue:0,
                                                rules: [
                                                    { required: true, message: 'Amount is required!' },
                                                    { validator: this.checkAmount}
                                                ],
                                            })( 
                                        <InputNumber
                                                min={0}
                                                precision={2}
                                        />
                                            )}
                                    </Item>
                                </Col>
                                <Col span={12}>
                                    <Item
                                        className="action-form-item"
                                        label="Discount"
                                        >
                                        {getFieldDecorator('discount',{
                                            rules:[
                                                {required:true}
                                            ]
                                        })(
                                         this.renderDiscountDropdown()
                                        )}
                                    </Item>
                                </Col>
                            </Row>
                           
                            <Row>
                                <Item
                                    className="action-form-item"
                                    label="Reason"
                                >
                                    {getFieldDecorator('reason',{
                                        rules:[
                                            {required:true}
                                        ]
                                    })(
                                        <TextArea
                                            rows={2}
                                        />
                                    )}
                                </Item>
                            </Row>
                            <Row style={{marginTop:8}} type="flex" justify="end">
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </Row>
                        </Form>
		)
	}
    
    componentWillMount(){
    }

    renderDiscountDropdown = ()=>{
        return (
            <Select style={{ width: 120 }}>
                <Option value="0">0%</Option>
                <Option value="5">5%</Option>
                <Option value="10">10%</Option>
                <Option value="15">15%</Option>
                <Option value="20">20%</Option>
            </Select>
        )
    }

    checkAmount=(rule, value, callback)=>{
        if (value <= 0) {
          callback('Amount cannot be negative!');
        } else {
          callback();
        }
    }

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFieldsAndScroll((err, values) => {
		  if (!err) {

                const { reason, amount, discount } = values

                _postAddCreditNote({
                    cartId:this.props.cartId,
                    reason,
                    amount,
                    discount
                })
                .then( res => {
                    if(res.data.success){
                        message.success("Added credit note!")
                        this.props.closePopover()
                    } else {
                        message.error("Failed to add!")
                    }
                })
		  }
		});
	  }
}

export default Form.create({})(CreditNoteForm);


// WEBPACK FOOTER //
// ./src/components/orders-v2/creditNoteForm.js